import type { FetchListParams } from 'Services/ServiceProviderManagement/types'

export enum ServiceProviderTabType {
  DETAILS = 'details',
  SALES_POINTS = 'sales_points',
  ALLOWED_API_CLIENTS = 'allowed_api_clients'
}

export interface ServiceProvider {
  owner_client: string
  client_read: string[]
  client_write: string[]
  service_provider_id: string
  pta: string
  type: ServiceProviderType
  start_date: Date
  active: boolean
  activity_end_date: Date | null
  s365t_account_id: string
  name: string
  customer_reference_name: string
  business_id: string
  billed_at_sales_point_level: boolean
  transfer_sales_to_financial_system: boolean
  register_file_path: string
  register_file_name: string
  register_ok_file_name: string
  register_not_ok_file_name: string
  vrk_queries_enabled: boolean
  cpu_url: string
  pusatec_channel: string
  created_timestamp: Date
  modified_timestamp: Date
  last_modified_client: string
  source: string
}

export enum ServiceProviderType {
  TRAFFIC_CONTRACTOR = 'TRAFFIC_CONTRACTOR',
  U_TRAFFIC_CONTRACTOR = 'U_TRAFFIC_CONTRACTOR',
  SALES_POINT = 'SALES_POINT',
  SERVICE_POINT = 'SERVICE_POINT',
  HSL_DIGITAL_CHANNEL = 'HSL_DIGITAL_CHANNEL',
  MAAS = 'MAAS',
  OTHER = 'OTHER',
  TICKET_MACHINE = 'TICKET_MACHINE',
  WEBSHOP = 'WEBSHOP',
  MOBILE = 'MOBILE',
  EVENT_TICKET = 'EVENT_TICKET'
}

export interface FetchServiceProviderListParams extends FetchListParams {
  active?: boolean
  type?: ServiceProviderType
}
